<label
  class="default-label document-check"
  (click)="$event.stopPropagation()"
  *ngIf="displaySelectionCheckbox"
>
  <input type="checkbox" [ngModel]="selected" (ngModelChange)="toggleSelection()" />
</label>
<ng-content></ng-content>
